import React from "react";
import { useLinks } from "../../../state/api/links/useLinks";
import PageLoader from "../loader/PageLoader";
import UsefulLink from "./UsefulLink";

export default function UsefulLinks() {
  const {
    links,
    isLoading
  } = useLinks();

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <div className="d-flex flex-column gap-3 ps-3 pe-3 pe-sm-4 ps-sm-4 h-100" style={{ overflowY: "auto" }} >
      {
        links?.length
          ? links.map(d => <UsefulLink link={d} key={d._id} />)
          : (
            <div className="p-3">
              <span>No links available</span>
            </div>
          )
      }
    </div>
  )
}